'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { DeclarativeModal } from '#pplx/frontend/aether/modals/utils/DeclarativeModal.js';
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
import React, { useMemo } from 'react';
const WindowsLegacyAppUpsellModal = Dynamic(async () => {
    const { WindowsLegacyAppUpsellModal } = await import('#pplx/frontend/apps/ask/upsell-slots/homepage-top-banner/internal/WindowsLegacyAppUpsellModal.js');
    return { default: WindowsLegacyAppUpsellModal };
});
export const WindowsLegacyAppUpsellModalSlot = ({ plan }) => {
    const modalProps = useMemo(() => ({ onClose: plan.close, onGetApp: plan.close }), [plan.close]);
    return plan.show ? (_jsx(DeclarativeModal, { modal: WindowsLegacyAppUpsellModal, props: modalProps })) : null;
};
//# sourceMappingURL=WindowsLegacyAppUpsellModalSlot.js.map